import { z } from 'zod';

export const GetCouponsServiceRequestSchema = z
  .object({
    shopTitle: z.string(),
    page: z.number().int().nonnegative().optional(),
    size: z.number().int().positive().optional(),
  })
  .describe('GetCouponsServiceRequest');

export type GetCouponsServiceRequest = z.infer<typeof GetCouponsServiceRequestSchema>;

export const CouponItemDtoSchema = z
  .object({
    couponNo: z.number().int(),
    couponName: z.string(),
    salesRate: z.number(),
    useStartDate: z.string(),
    useEndDate: z.string(),
    status: z.enum(['AVAILABLE', 'RECEIVED', 'EXHAUSTED', 'EXPIRED']),
    brandId: z.string(),
    expirationText: z.string(),
  })
  .describe('CouponItemDto');

export type CouponItemDto = z.infer<typeof CouponItemDtoSchema>;

export const GetCouponsServiceResponseSchema = z
  .object({
    list: z.array(CouponItemDtoSchema),
    pagination: z.object({
      hasNextPage: z.boolean(),
      nextPage: z.number().int().optional(),
    }),
  })
  .describe('GetCouponsServiceResponse');

export type GetCouponsServiceResponse = z.infer<typeof GetCouponsServiceResponseSchema>;
